module.exports = __webpack_public_path__ + "img/Group 242.d740d0a6.svg";